import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const growAnimation = trigger('growAnimation', [
  transition(':enter', [
    style({ maxHeight: '0' }),
    animate('300ms', style({ maxHeight: '300px' })),
  ]),
  transition(':leave', [
    animate('100ms', style({ opacity: 0 })),
    animate('200ms', style({ maxHeight: '0' })),
  ]),
]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: '0' }),
    animate('300ms', style({ opacity: '1' })),
  ]),
  transition(':leave', [
    animate('100ms', style({ opacity: 0 })),
    animate('200ms', style({ maxHeight: '0' })),
  ]),
]);

export const listFadeAnimation = ({ delay = 0, staggerSpeed = 100 }) =>
  trigger('listFadeAnimation', [
    transition('* => *', [
      query(
        ':enter',
        [
          style({ opacity: 0 }),
          stagger(staggerSpeed, [
            animate(`500ms ${delay}ms`, style({ opacity: 1 })),
          ]),
        ],
        { optional: true }
      ),
    ]),
  ]);

export const slideAnimation = trigger('slideAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(-90%)' }),
    animate('200ms', style({ transform: 'translateX(0)' })),
  ]),
  transition(':leave', [
    animate('200ms', style({ transform: 'translateX(-90%)' })),
  ]),
]);
